var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, styled } from '@mui/material';
import { useContext, useMemo } from 'react';
import { RumEntityLabel } from '../../../observability/rumEntity';
import { useTerminologyTranslation } from '../../app/terminology';
import { Autocomplete, getLOBName, getUnassignedLOB, renderGroupedOptions, sortByLOBName } from '../../common';
import { WizardContext } from '../context';
import { useQueuesAPI } from '../queue/selectors';
import { usePlanAPI, useWizardParams } from '../selectors';
import { usePlanColor } from './selectors';
var StyledTitleBar = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.common.white,
    });
});
var StyledAutocomplete = styled(Autocomplete)(function (_a) {
    var theme = _a.theme;
    return ({
        width: theme.typography.pxToRem(440),
    });
});
export var TitleBar = function () {
    var _a, _b, _c;
    var t = useTerminologyTranslation('wizard').t;
    var queuesData = useQueuesAPI()[0];
    var queueId = useWizardParams().queueId;
    var bgcolor = usePlanColor()[0];
    var planData = usePlanAPI()[0];
    var _d = useContext(WizardContext), handleSave = _d.handleSave, actionRef = _d.actionRef, requesting = _d.requesting, goToQueue = _d.goToQueue;
    var sortedQueues = useMemo(function () {
        var _a;
        var unassigned = getUnassignedLOB();
        return __spreadArray([], ((_a = queuesData.data) !== null && _a !== void 0 ? _a : []), true).map(function (q) { return (__assign(__assign({}, q), { _lobLabel: getLOBName(q.lobName, q.subLobName, unassigned) })); })
            .sort(function (a, b) { return sortByLOBName(__assign(__assign({}, a), { lobName: a._lobLabel }), __assign(__assign({}, b), { lobName: b._lobLabel }), unassigned); });
    }, [queuesData.data]);
    return (_jsxs(StyledTitleBar, __assign({ bgcolor: bgcolor, padding: 4, borderRadius: 1, direction: "row", alignItems: "center", gap: 4 }, { children: [_jsx(Typography, __assign({ variant: "subtitle1" }, { children: ((_a = planData.data) === null || _a === void 0 ? void 0 : _a.isBaseline) ? (t('review.baseline')) : (_jsx(RumEntityLabel, __assign({ kind: "scenario", id: (_b = planData.data) === null || _b === void 0 ? void 0 : _b.id }, { children: (_c = planData.data) === null || _c === void 0 ? void 0 : _c.name }))) })), _jsx(Typography, __assign({ marginLeft: "auto" }, { children: t('copyData.placeholder') })), _jsx(StyledAutocomplete, { value: queueId, options: sortedQueues, groupBy: function (option) { return option._lobLabel; }, renderGroup: renderGroupedOptions, onChange: function (id) { return handleSave('switchQueue', function () { return goToQueue(id); })(); }, loading: actionRef.current === 'switchQueue' && requesting, rumEntity: "queue" })] })));
};
